/* global axios */

import ApiClient from './ApiClient';

class EvolutionAPI extends ApiClient {
  constructor() {
    super('evolution/instances', { accountScoped: true });
  }

  listInstances() {
    return axios.get(this.url);
  }

  connect(instanceName) {
    return axios.post(
      `${this.url}/${encodeURIComponent(instanceName)}/connect`
    );
  }

  logout(instanceName) {
    return axios.delete(
      `${this.url}/${encodeURIComponent(instanceName)}/logout`
    );
  }
}

export default new EvolutionAPI();
